module.exports = __webpack_public_path__ + "img/product2.dfdcb579.png";